import React, { useEffect, useState } from "react";
import "./ImageSection.css";

import leftImage from "../../../assets/left-image1.jpg";
import rightImage from "../../../assets/right-image2.jpg";
import StartImage from "../../../assets/start-image3.jpeg";

function ImageSection() {
  const [currentImage, setCurrentImage] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) =>
        prevImage === 1 ? 2 : prevImage === 2 ? 3 : 1
      );
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="custom-image-section1">
      <div className="custom-content-section">
        <h2 className="custom-content-title">Snáithe’s Vision</h2>
        <p className="custom-content-text">
          In the heart of Sweden, emerges Snáithe - a visionary company
          committed to surpassing industry standards across a spectrum of
          sectors. With an unwavering dedication to excellence, Snáithe stands
          as a beacon of trustworthiness and reliability, consistently
          delivering results that redefine success.
          <br></br>
          <br></br>
          Our Multifaceted Reach: A Commitment to Excellence At Snáithe, we
          thrive across a multitude of sectors, each serving as a testament to
          our versatility and proficiency. From the dynamic world of business
          and government sectors to the rapidly evolving realms of education and
          IT, we navigate the intricate landscape of industries with finesse and
          precision. Our mastery extends seamlessly into cutting-edge domains
          such as AI and artificial intelligence technology, propelling the
          frontiers of innovation.
        </p>
      </div>
      <div className="custom-images-container">
        <div
          className={`custom-image-container custom-left-slide ${
            currentImage === 1 ? "active" : ""
          }`}
        >
          <img src={StartImage} alt="StartImage" />
        </div>
        <div
          className={`custom-image-container custom-left-slide ${
            currentImage === 2 ? "active" : ""
          }`}
        >
          <img src={leftImage} alt="Left Image 1" />
        </div>
        <div
          className={`custom-image-container custom-right-slide ${
            currentImage === 3 ? "active" : ""
          }`}
        >
          <img src={rightImage} alt="Right Image 2" />
        </div>
      </div>
      <div className="custom-content-section">
        <h2 className="custom-content-title-2">Vision Start</h2>
        <p className="custom-content-text-2">
          In the heart of Sweden, emerges Snáithe - a visionary company
          committed to surpassing industry standards across a spectrum of
          sectors. With an unwavering dedication to excellence, Snáithe stands
          as a beacon of trustworthiness and reliability, consistently
          delivering results that redefine success.
          <br></br>
          <br></br>
          Our Multifaceted Reach: A Commitment to Excellence At Snáithe, we
          thrive across a multitude of sectors, each serving as a testament to
          our versatility and proficiency. From the dynamic world of business
          and government sectors to the rapidly evolving realms of education and
          IT, we navigate the intricate landscape of industries with finesse and
          precision. Our mastery extends seamlessly into cutting-edge domains
          such as AI and artificial intelligence technology, propelling the
          frontiers of innovation.
        </p>
     
      </div>
    </div>
  );
}

export default ImageSection;
